import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-54bda964")

_pushScopeId("data-v-54bda964")
const _hoisted_1 = {
  key: 1,
  class: "symbol-label fs-8 fw-bolder bg-light-primary text-primary"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["symbol symbol-circle flex-shrink-0 social-account-avatar", _ctx.sizeClass],
    style: _ctx.sizeStyle
  }, [
    (_ctx.showImage)
      ? (_openBlock(), _createBlock("img", {
          key: 0,
          src: _ctx.avatar,
          alt: _ctx.altText,
          class: "social-account-avatar__img",
          onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onImageError && _ctx.onImageError(...args)))
        }, null, 40, ["src", "alt"]))
      : (_openBlock(), _createBlock("span", _hoisted_1, _toDisplayString(_ctx.initials), 1))
  ], 6))
})